import { DoseType, DoseUnit } from '~/domain/dicom/dicomDose';
import { DomainValidationError } from '~/domain/errors/DomainError';

export class DoseInputError extends DomainValidationError {
    constructor(
        message: string,
        readonly messageId: string
    ) {
        super(message);
    }
}

// A factor this far from 1 is accepted but worth a second look.
const UNUSUAL_FACTOR_LOW = 0.5;
const UNUSUAL_FACTOR_HIGH = 2;

export function validateDoseScale(scale: number): void {
    if (!Number.isFinite(scale) || scale <= 0) {
        throw new DoseInputError(
            'Dose scale must be a finite number greater than 0.',
            'dose.error.scale'
        );
    }
}

// Only a physical dose in Gy is scaled or summed: the result is written as one.
export function validatePhysicalGy(dose: {
    readonly dicomDose: {
        readonly doseUnits: DoseUnit;
        readonly doseType: DoseType;
    };
}): void {
    if (
        dose.dicomDose.doseUnits !== DoseUnit.GY ||
        dose.dicomDose.doseType !== DoseType.PHYSICAL
    ) {
        throw new DoseInputError(
            'Only a physical dose in Gy can be scaled or summed.',
            'dose.error.notPhysicalGy'
        );
    }
}

export function isUnusualDoseFactor(factor: number): boolean {
    return (
        Number.isFinite(factor) &&
        factor > 0 &&
        (factor < UNUSUAL_FACTOR_LOW || factor > UNUSUAL_FACTOR_HIGH)
    );
}
